import { render, staticRenderFns } from "./Withdrawhistory.vue?vue&type=template&id=a1a84d90&"
import script from "./Withdrawhistory.vue?vue&type=script&lang=js&"
export * from "./Withdrawhistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports